<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.simple-hero {
    position: relative;
    z-index: auto;
    margin-bottom: 16px;

    @media screen and (min-width: $screen-md) {
        margin-bottom: 56px;
    }

    @media screen and (min-width: $screen-xl) {
        margin-bottom: 96px;
    }

    .hero {
        background-color: $primary;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: 40px 0 120px 0;
        position: relative;

        @media screen and (min-width: $screen-lg) {
            padding: 80px 0 120px 0;
        }

        @media screen and (min-width: $screen-xl) {
            padding: 158px 0 158px 0;
        }

        &.large {
            @media screen and (min-width: $screen-lg) {
                padding: 100px 0 180px 0;
            }

            @media screen and (min-width: $screen-xl) {
                padding: 160px 0 280px 0;
            }
        }

        &:before {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: '';
            background-color: rgba(43, 74, 132, 0.7);
        }

        .content {
            position: relative;
            z-index: 2;
        }
    }

    &:after {
        content: '';
        background-image: url('/svg/shapes/header-1.svg');
        height: 80px;
        width: 100%;
        position: absolute;
        z-index: 2;
        right: 0;
        bottom: 0;

        @media screen and (min-width: $screen-sm) {
            background-size: cover;
            background-repeat: no-repeat;
        }
    }
}
</style>

<template>
    <div class="simple-hero">
        <div class="hero" :class="{ large: large }" :style="possibleBackgroundImage">
            <div class="container content">
                <div class="flex flex-wrap">
                    <div class="w-full xl:w-10/12">
                        <div class="intro lg:flex">
                            <h1 class="text-44 xl:text-64 font-bold text-white">{{ title }}</h1>
                            <div class="text-white text-18 text-cut lg:ml-20 mb-child-0">
                                <p v-if="description" v-html="description"></p>
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        large: {
            type: Boolean,
            require: false,
            default: false,
        },
    },

    computed: {
        possibleBackgroundImage() {
            if (this.image) return `background-image: url('${this.image}')`;
            return '';
        },
    },
};
</script>
